import type { AutomationTemplateContents } from '@reach/shared-types/automation-template';
import { getSegmentDefaultIds } from '../segment-picker/segment-usage';
import type { SegmentPickerTab } from '../segment-picker/SegmentPickerTabs';
import type { SegmentDefinitionSummary } from '../segment-definitions-api';

type SegmentDefaults = AutomationTemplateContents['excludeSegmentDefaults'];

export const TRIGGER_DIALOG_SUBTITLES: Record<SegmentPickerTab, string> = {
  include: 'Choose the one segment that triggers this campaign',
  exclude: 'Optional: people in any of these segments won’t be sent anything from this campaign',
};

export const TRIGGER_SEGMENT_INTRO =
  'Pick one segment. Anyone who enters it starts this automation. Only one trigger segment is supported. To leave people out, use the Exclude segments tab, where you can pick several.';
export const DATE_AUDIENCE_SINGLE_SELECT_NOTE =
  'Pick one audience segment. To leave people out, use the Exclude segments tab, where you can pick several.';

export const SEGMENT_TRIGGER_TAB_LABEL = 'Trigger segment';
export const SEGMENT_TRIGGER_AUDIENCE_DESCRIPTION = 'everyone who enters the trigger segment runs';
export const DATE_TRIGGER_TAB_LABEL = 'Audience';
export const DATE_TRIGGER_AUDIENCE_DESCRIPTION = 'everyone in the audience gets this automation';

export const NO_EXCLUSION_CARD_LABEL = 'No exclusion';
export const SINGLE_EXCLUSION_CARD_PREFIX = 'Excluding anyone in:';
export const MULTIPLE_EXCLUSIONS_CARD_PREFIX = 'Excluding anyone in any of:';
export const MISSING_SEGMENT_NAME = 'a segment that no longer exists';

/** Exclusions to save, or null when unchanged so an untouched template isn't marked dirty. */
export function getNextExclusions(
  excludeSegmentDefaults: SegmentDefaults,
  excludedIds: string[],
): string[] | null {
  const currentIds = getSegmentDefaultIds(excludeSegmentDefaults);
  const isSameSelection =
    currentIds.length === excludedIds.length && currentIds.every(id => excludedIds.includes(id));
  return isSameSelection ? null : excludedIds;
}

/** Display names of a template's excluded segments, for the trigger card. */
export function getExclusionNames(
  excludeSegmentDefaults: SegmentDefaults,
  segmentDefinitions: SegmentDefinitionSummary[] | undefined,
): string[] {
  return getSegmentDefaultIds(excludeSegmentDefaults).map(
    id =>
      segmentDefinitions?.find(segment => segment.canonicalVersionId === id)?.name ??
      MISSING_SEGMENT_NAME,
  );
}
